export default __webpack_public_path__ + "static/media/AGE GLASS claims-09-03.6f91ce97.svg";